// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Components
const NotificationComponent = () => import(/* webpackPrefetch: true, webpackChunkName: 'notification-component' */ '@/app/views/main-view/_shared/_components/notification-component/notification-component.vue');

// Services
import NotificationService from '@/app/services/main/notifications/notifications-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
	name: 'TheHeader',
	mixins: [
		userMixins
	],
	components: {
		NotificationComponent
	},
	data() {
		return {
            hasProfileImage: false,
			unreadNotificationCount: 0
		}
	},
	created() {
		// Get the notification admin count
		NotificationService.getAdminNotificationList({ 'f_unreadCount': true })
			.then(res => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.unreadNotificationCount = res.data ? res.data.unreadCount : 0;
				}
			});
	},
	methods: {
		toggleSideBar() {
			this.$store.commit('toggleSideBar');
		},
		logoutUser() {
			this.$store.dispatch('logout');
        },
		getAdminNotificationList() {
			this.$refs.notificationComponent.refreshNotification();
		},
		notificationCount(count) {
			this.unreadNotificationCount = count;
		}
	}
}